<div class="d-flex flex-column justify-content-between">
  @if (!state.verifyingUssd && !state.bankSelected && !state.error) {
    <div class="row">
      <div class="form-group col-mb-12 mb-2">
        <div class="group-input">
          <label
            for="phone"
            class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
            >Bank</label
            >
            <div class="zp:relative zp:inline-block zp:w-full">
              <select
                id="banks"
                [(ngModel)]="bankOption"
                name="bank"
                aria-label="bank"
                placeholder="Select user bank"
                (change)="selectBank()"
                required
                class="zp:appearance-none zp:bg-gray-50 zp:border zp:border-gray-300 zp:text-gray-900 zp:text-sm zp:rounded-lg zp:focus:ring-ZTG-500 zp:focus:border-ZTG-500 zp:block zp:w-full zp:p-2.5 zp:outline-ZTG-500"
                >
                <option [value]="null" [disabled]="true" [selected]>
                  Select Bank
                </option>
                @for (option of responseData; track option) {
                  <option [ngValue]="option">
                    {{ option.bankName }}
                  </option>
                }
              </select>
              <div
                class="zp:pointer-events-none zp:absolute zp:inset-y-0 zp:right-2 zp:flex zp:items-center"
                >
                <!-- Dropdown Icon -->
                <svg
                  class="zp:w-4 zp:h-4 zp:text-gray-500 zp:ml-2"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                    />
                </svg>
              </div>
            </div>
            <div>
              <p class="pay-notice">You can send up to &#8358;20,000 per transfer.</p>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!state.verifyingUssd && state.bankSelected && !state.error) {
      @if (state.visible) {
        <div class="zp:bg-ZTN-50 zp:rounded-lg zp:border zp:border-ZTN-200">
          <header
            class="zp:text-center zp:text-ZTN-500 zp:font-medium zp:text-sm zp:py-4"
            >
            <div class="zp:text-sm zp:text-ZTN-600">
              Dial the code below to complete this transaction with
              {{ bankOption.bankName }}
            </div>
          </header>
          <div
            class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:m-1"
            >
            <div
              class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-4 zp:basis-full"
              >
              <div class="zp:flex zp:justify-center zp:items-center zp:mb-4">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <circle cx="28" cy="28" r="28" fill="#F2F4F7" />
                  <path
                    d="M26.5 17.5H24.25C23.6533 17.5 23.081 17.7371 22.659 18.159C22.2371 18.581 22 19.1533 22 19.75V36.25C22 36.8467 22.2371 37.419 22.659 37.841C23.081 38.2629 23.6533 38.5 24.25 38.5H31.75C32.3467 38.5 32.919 38.2629 33.341 37.841C33.7629 37.419 34 36.8467 34 36.25V19.75C34 19.1533 33.7629 18.581 33.341 18.159C32.919 17.7371 32.3467 17.5 31.75 17.5H29.5M26.5 17.5V19H29.5V17.5M26.5 17.5H29.5M26.5 36.25H29.5"
                    stroke="#101828"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    />
                </svg>
              </div>
              <div class="shortcode">
                <div class="shortcode__content">
                  <div class="zp:text-center zp:px-9 zp:max-w-full">
                    <div class="zp:text-ZTN-500 zp:font-medium zp:text-sm">
                      <p class="zp:text-ZTN-500 zp:block zp:text-sm zp:leading-6">
                        {{ bankOption.bankName }}
                      </p>
                      <div
                        class="zp:flex zp:justify-center zp:items-center zp:gap-x-2 zp:pb-4 zp:pt-2"
                        >
                        <p
                          class="zp:block zp:text-base zp:text-ZTN-900 zp:font-bold"
                          >
                          {{ bankOption.bankUssdCode }}
                        </p>
                        <p>
                          @if (!copied) {
                            <span
                              role="button"
                              (click)="copyToClipboard()"
                              class="zp:ml-2 zp:flex zp:item-center zp:cursor-pointer"
                              >
                              <span class="zp:w-4 zp:h-4">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  >
                                  <g clip-path="url(#clip0_1576_42778)">
                                    <path
                                      d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                                      stroke="#4F499F"
                                      stroke-width="1.4"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      />
                                    <path
                                      d="M3.33337 9.99998H2.66671C1.93033 9.99998 1.33337 9.40305 1.33337 8.66665V2.66665C1.33337 1.93027 1.93033 1.33331 2.66671 1.33331H8.66671C9.40311 1.33331 10 1.93027 10 2.66665V3.33331"
                                      stroke="#4F499F"
                                      stroke-width="1.4"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1576_42778">
                                      <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              <span
                                class="zp:ml-1 zp:text-xs zp:font-medium zp:text-ZTP-800"
                                >Copy</span
                                >
                              </span>
                            }
                            @if (copied) {
                              <span
                                class="zp:ml-2 zp:text-xs zp:font-medium zp:text-ZTP-800"
                                >{{ copyMessage }}</span
                                >
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                      <p class="zp:text-sm zp:text-ZTN-500">
                        You can send up to N20,000 per transfer
                      </p>
                    </div>
                  </div>
                  <!-- <div class="zp:text-center zp:px-9 zp:py-3 zp:w-full zp:text-xs">
                  <p class="zp:font-normal zp:text-xs zp:text-ZTN-400">Loading...</p>
                  <p class="zp:text-ZTN-500 zp:font-medium zp:text-xs zp:pt-2">
                    {{ ussdExpired ? "USSD Code expired" : "USSD Code expires in" }}
                    <span></span>
                    <span class="zp:text-ZTP-800" *ngIf="!ussdExpired"
                      >{{ display }} minutes</span
                      >
                    </p>
                  </div> -->
                  <div id="cancel-link" class="zp:pt-4">
                    <button
                      type="button"
                      (click)="cancelProcess()"
                      class="zp:text-ZTN-900 zp:font-medium zp:cursor-pointer zp:border zp:border-ZTN-300 zp:text-xs zp:rounded-2xl zp:py-2 zp:px-3 zp:bg-ZTN-50"
                      >
                      Select another bank
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="w-full text-center pt-4">
            <div *ngIf="!ussdExpired" style="color: #677684" class="fz-12">
              USSD Code will expire in
              <span class="fw-sbold" *ngIf="display; else loading">{{ display }}</span>
              <ng-template #loading> Loading... </ng-template>
            </div>
            <div *ngIf="ussdExpired" class="text-danger fz-12 fw-sbold">USSD Code expired</div>
            <a class="fz-14 code-resend-link"> Resend Now </a>
          </div> -->
        }
      }
      @if (state.verifyingUssd) {
        <div class="verification-loader">
          <span class="omni-spinner-text">{{ loadingMessage }}</span>
          <div class="omni-spinner-border" role="status"></div>
        </div>
      }
      @if (state.error) {
        <div
          class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
          >
          <div
            class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
            >
            <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
              <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
            </div>
            <div class="px-3">
              <div
                class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
                >
                We could not process this transaction
              </div>
              <div class="zp:text-sm zp:text-ZTN-500 zp:font-normal zp:leading-5">
                <small class="zp:text-sm">
                  {{ errorMessage }}
                </small>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
